export default "__VITE_ASSET__DJWZS2hD__"